// extracted by mini-css-extract-plugin
module.exports = {"titles":"HeroBannerPromoFamily_titles__TLajn","titlesWrapper":"HeroBannerPromoFamily_titlesWrapper__8lGlu"};